import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../utils/api';

const BecomeInstructor = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        expertise: '',
        bio: '',
        linkedIn: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/instructors/apply', formData);
            toast.success('Your application has been submitted successfully! We will get back to you soon.');
            setFormData({ name: '', email: '', expertise: '', bio: '', linkedIn: '' });
        } catch (error) {
            const message =
                error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'There was an error submitting your application. Please try again.';
            toast.error(message);
            console.error('Application submission error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Join Our Team</h6>
                    <h1 className="mb-5">Become an Instructor</h1>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
                        <p className="mb-4">
                            Are you passionate about sharing your knowledge and skills with an eager audience? Join Fundisha as an instructor and help shape the future of learning. Fill out the form below to apply.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="name" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
                                        <label htmlFor="name">Your Name</label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="email" className="form-control" id="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
                                        <label htmlFor="email">Your Email</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="expertise" name="expertise" placeholder="e.g., Web Development, Graphic Design" value={formData.expertise} onChange={handleChange} required />
                                        <label htmlFor="expertise">Your Area of Expertise</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea className="form-control" placeholder="Tell us a little about yourself" id="bio" name="bio" style={{ height: '150px' }} value={formData.bio} onChange={handleChange} required></textarea>
                                        <label htmlFor="bio">Your Bio</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input type="url" className="form-control" id="linkedIn" name="linkedIn" placeholder="LinkedIn Profile URL" value={formData.linkedIn} onChange={handleChange} />
                                        <label htmlFor="linkedIn">LinkedIn Profile (Optional)</label>
                                    </div>
                                </div>
                                <div className="col-12 text-center">
                                    <button className="btn btn-primary w-100 py-3" type="submit" disabled={loading}>
                                        {loading ? 'Submitting...' : 'Submit Application'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BecomeInstructor; 